module.exports = __webpack_public_path__ + "static/media/Mt.FujiJapan-sunset.b459116c.svg";